import { Shop } from '@mui/icons-material';
// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const shopPurchase = {
    id: 'shopPurchase',
    // title: 'Dashboard',
    type: 'group',
    children: [
        {
            id: 'shopPurchase',
            title: 'Shop Purchase',
            type: 'item',
            url: '/shop-purchase',
            icon: Shop,
            breadcrumbs: false
        }
    ]
};

export default shopPurchase;
